export const cashierSettingTheme = {
  bottomBorder: {
    borderColor: 'palette.surface.1',
    borderWidth: '1px',
  },
  label: {
    text: 'palette.tertiary.60',
  },
};
